import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/custom/components/organisms/User/Tabs/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })
    const history = useHistory()

    const { user_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 1,
        emp_type: 'seller',
    }

    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setManage({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                user_type: 0,
                // secondaryID: props?.match?.params?.sid,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            console.log(user_dynamicfields, 'userr')
            let dynamicValueAssign = []
            user_dynamicfields.map((item) => {
                item.view_on
                    ? item.view_on.includes('4')
                        ? dynamicValueAssign.push(item)
                        : {}
                    : dynamicValueAssign.push(item)
            })
            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })

            if (props?.match?.params?.id != 0) {
                const temp = dynamicValueAssign
                    .filter(
                        (item) =>
                            item.name != 'password' &&
                            item.name != 'confirm_password' &&
                            item.for_organization === 1
                    )
                    .map((item) => {
                        if (item.name === 'fill_others') {
                            return {
                                ...item,
                                label: '',
                                // placeholder: '',
                            }
                        }
                        return item
                    })

                setFieldValue(temp)
            } else if (props?.match?.params?.id == 0) {
                const temp = dynamicValueAssign
                    .filter(
                        (item) =>
                            item.name != 'password' &&
                            item.name != 'confirm_password' &&
                            item.name != 'how_they_learned_about_us' &&
                            item.name != 'fill_others' &&
                            item.for_organization === 1
                    )
                    .map((item) => {
                        if (item.name === 'fill_others') {
                            return {
                                ...item,
                                label: '',
                                // placeholder: '',
                            }
                        }
                        return item
                    })

                setFieldValue(temp)
            }
        }
    }, [user_dynamicfields, props?.match?.params?.id])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    customInitial={customInitial}
                    data={manage}
                    function={closeFunction}
                    additionalFieldUpdate={additionalFieldUpdate}
                    seller={true}
                    // populateValidation={true}
                    standalone={true}
                />
            </Layout>
        </>
    )
}

export default UserCommon
